import { LoadingOutlined } from "@ant-design/icons";
import { Badge, Button } from "antd";
import { FC, useEffect } from "react";
import { BsChatDots } from "react-icons/bs";

import { useDevice } from "@app/shared/lib/DeviceProvider";
import { useSdk } from "@app/shared/lib/hooks";

import { Header } from "../Header";

export const Chat: FC = () => {
  const device = useDevice();
  const sdk = useSdk();

  useEffect(() => {
    const dispose = sdk.hub.school.supportChatEnabled.subscribe(
      (enabled: boolean) => {
        if (!enabled) {
          device.closeChat();
        }
      },
    );

    return () => dispose();
  }, [device.closeChat, sdk.hub.school.supportChatEnabled]);

  return (
    <Header.Item onClick={device.toggleChat}>
      <Badge count={device.chatUnreadCount}>
        <Button
          icon={device.isChatInited ? <BsChatDots /> : <LoadingOutlined />}
          type="link"
          shape="circle"
          className="bg-gray-3 secondary-text"
        />
      </Badge>
    </Header.Item>
  );
};
